import { Avatar, Tooltip } from "@mui/material";
import { t } from "i18next";
import { ReactNode, createElement } from "react";
import { TbUser } from "react-icons/tb";

import { softColors } from "@/constants/colors";
import { PERMISSION_IDS } from "@/constants/permissions";
import { UserTypeItem, userTypes } from "@/constants/userTypes";
import { capitalizeWords } from "@/helpers/strings";
import { UserType } from "@/types/user.types";

import ClipBoard from "./ClipBoard";

function DriverAvatar({
    name,
    isDeleted,
    userType,
    avatar,
    children,
    blackIcon,
    withoutClipBoard,
    className,
    iconSize,
}: {
    avatar?: boolean;
    userType?: UserType;
    name: string;
    isDeleted?: boolean;
    children?: ReactNode;
    blackIcon?: boolean;
    withoutClipBoard?: boolean;
    className?: string;
    iconSize?: number;
}) {
    const currentUser: UserTypeItem = (userType && userTypes.find((status) => status.values.includes(userType))) || {
        component() {
            return TbUser;
        },
        getLabel() {
            return "";
        },
        tooltip: {
            title: "",
            description: "",
        },
        ...softColors.brown,
        value: UserType.DRIVER,
        values: [],
        show: true,
        permissionId: PERMISSION_IDS[UserType.DRIVER],
    };

    return (
        <div className={`flex w-full  items-center h-full gap-2  `}>
            {avatar && (
                <Tooltip title={isDeleted ? t("userDeleted") : capitalizeWords(name || "")}>
                    <Avatar
                        sx={{
                            width: (iconSize && iconSize + 6) || 26,
                            height: (iconSize && iconSize + 6) || 26,
                            color: (blackIcon && "black") || currentUser.text,
                            backgroundColor: currentUser.bg,
                        }}
                        className={
                            "ring !ml-1 " + (isDeleted ? "ring-red-300 !bg-red-100 !text-red-700" : "ring-slate-100")
                        }
                        variant="circular"
                    >
                        {createElement(currentUser.component(), { fontSize: iconSize || 14 })}
                    </Avatar>
                </Tooltip>
            )}
            <div
                className={`font-semibold  text-gray-900 !capitalize break-all w-full flex items-center gap-1 justify-between ${className || ""}`}
            >
                {withoutClipBoard ? (
                    capitalizeWords(name || "")
                ) : (
                    <ClipBoard text={name}>{capitalizeWords(name || "")}</ClipBoard>
                )}
                {children}
            </div>
        </div>
    );
}

export default DriverAvatar;
